(function () {
  var MOBILE_NAV_MQ = window.matchMedia('(max-width: 590px)');

  function isMobileNav() {
    return MOBILE_NAV_MQ.matches;
  }

  function syncNavGroupLabels(root) {
    root.querySelectorAll('.nav_item').forEach(function (item) {
      var list = item.querySelector('.second_list');
      var heading = item.querySelector('.first_level--desktop');
      var toggle = item.querySelector('[data-faq-cat-toggle]');
      if (!list || !heading || !toggle) return;
      list.setAttribute('aria-labelledby', isMobileNav() ? toggle.id : heading.id);
    });
  }

  function enhanceFaqItems(root) {
    root.querySelectorAll('.faq_item').forEach(function (item, index) {
      var ask = item.querySelector('.ask');
      var answer = item.querySelector('.answer');
      if (!ask || !answer) return;

      var askId = ask.id || 'faq-ask-' + index;
      var answerId = answer.id || 'faq-answer-' + index;
      ask.id = askId;
      answer.id = answerId;

      if (ask.tagName !== 'BUTTON') {
        ask.setAttribute('role', 'button');
        ask.setAttribute('tabindex', '0');
      }

      var isOpen = item.classList.contains('active');
      ask.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      ask.setAttribute('aria-controls', answerId);
      answer.setAttribute('role', 'region');
      answer.setAttribute('aria-labelledby', askId);

      if (!isOpen) {
        answer.hidden = true;
        answer.style.display = 'none';
      }
    });
  }

  function toggleFaqItem(item) {
    var ask = item.querySelector('.ask');
    var answer = item.querySelector('.answer');
    if (!ask || !answer) return;

    var isOpen = item.classList.contains('active');
    var container = item.closest('.faq_container');
    if (container) {
      container.querySelectorAll('.faq_item.active').forEach(function (openItem) {
        if (openItem === item) return;
        openItem.classList.remove('active');
        var openAsk = openItem.querySelector('.ask');
        var openAnswer = openItem.querySelector('.answer');
        if (openAsk) openAsk.setAttribute('aria-expanded', 'false');
        if (openAnswer) {
          openAnswer.hidden = true;
          openAnswer.style.display = 'none';
        }
      });
    }

    if (isOpen) {
      item.classList.remove('active');
      ask.setAttribute('aria-expanded', 'false');
      answer.hidden = true;
      answer.style.display = 'none';
    } else {
      item.classList.add('active');
      ask.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      answer.style.display = 'block';
    }
  }

  function initFaqMainContent(root) {
    if (!root || root.dataset.faqMainInit === '1') return;
    root.dataset.faqMainInit = '1';

    enhanceFaqItems(root);
    syncNavGroupLabels(root);

    if (!root.dataset.faqNavA11yBound) {
      root.dataset.faqNavA11yBound = '1';
      MOBILE_NAV_MQ.addEventListener('change', function () {
        syncNavGroupLabels(root);
      });
    }

    root.addEventListener('click', function (event) {
      var ask = event.target.closest('.ask');
      if (ask && root.contains(ask)) {
        event.preventDefault();
        var item = ask.closest('.faq_item');
        if (item) toggleFaqItem(item);
        return;
      }

      var navBtn = event.target.closest('[data-faq-nav]');
      if (navBtn && root.contains(navBtn)) {
        event.preventDefault();
        handleNavClick(root, navBtn);
        return;
      }

      var clearBtn = event.target.closest('[data-faq-clear-search]');
      if (clearBtn && root.contains(clearBtn)) {
        resetSearch(root);
        return;
      }

      var catToggle = event.target.closest('[data-faq-cat-toggle]');
      if (catToggle && root.contains(catToggle) && isMobileNav()) {
        handleMobileCategory(root, catToggle);
      }
    });

    root.addEventListener('keydown', function (event) {
      var ask = event.target.closest('.ask');
      if (!ask || !root.contains(ask)) return;
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      var item = ask.closest('.faq_item');
      if (item) toggleFaqItem(item);
    });

    var searchForm = document.getElementById('faq_search');
    if (searchForm) {
      searchForm.addEventListener('submit', function (event) {
        event.preventDefault();
        event.stopPropagation();
        var input = searchForm.querySelector('input');
        var keyword = input ? input.value.trim() : '';
        handleSearch(root, keyword);
      });
    }

    initMobileNavScroll(root);
  }

  function handleNavClick(root, navBtn) {
    root.querySelectorAll('[data-faq-nav]').forEach(function (btn) {
      btn.classList.remove('active');
    });
    navBtn.classList.add('active');
    navBtn
      .closest('.nav_item')
      .classList.add('active');
    root.querySelectorAll('.nav_item').forEach(function (item) {
      if (item.contains(navBtn)) return;
      item.classList.remove('active');
      item.querySelector('[data-faq-cat-toggle]')?.setAttribute('aria-expanded', 'false');
    });
    navBtn.closest('.nav_item')?.querySelector('[data-faq-cat-toggle]')?.setAttribute('aria-expanded', 'true');

    var type = navBtn.getAttribute('data-type');
    var target = root.querySelector('.faq_container[data-type="' + type + '"]');
    if (!target) return;

    var top = target.getBoundingClientRect().top + window.pageYOffset;
    var header = document.querySelector('.header-wrapper');
    if (header && window.pageYOffset > top) top -= header.offsetHeight;

    var nav = root.querySelector('.faq_navigation');
    if (isMobileNav() && nav && nav.classList.contains('fixed')) {
      top -= nav.offsetHeight;
    }

    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function handleMobileCategory(root, toggle) {
    var navItem = toggle.closest('.nav_item');
    if (!navItem) return;

    if (navItem.classList.contains('active')) return;

    root.querySelectorAll('.nav_item').forEach(function (item) {
      item.classList.remove('active');
      item.querySelector('[data-faq-cat-toggle]')?.setAttribute('aria-expanded', 'false');
      var list = item.querySelector('.second_list');
      if (list) list.style.display = 'none';
      item.querySelectorAll('[data-faq-nav]').forEach(function (btn) {
        btn.classList.remove('active');
      });
    });

    navItem.classList.add('active');
    toggle.setAttribute('aria-expanded', 'true');
    var secondList = navItem.querySelector('.second_list');
    if (secondList) secondList.style.display = 'flex';

    var firstSub = navItem.querySelector('[data-faq-nav]');
    if (firstSub) {
      firstSub.classList.add('active');
      handleNavClick(root, firstSub);
    }
  }

  function resetSearch(root) {
    root.querySelectorAll('.faq_container .faq_item').forEach(function (item) {
      item.style.display = '';
    });
    var nav = root.querySelector('.faq_navigation');
    if (nav) nav.style.display = '';
    var searchResult = root.querySelector('.search_result');
    if (searchResult) searchResult.hidden = true;
    var noResult = root.querySelector('.no_result_message');
    if (noResult) noResult.hidden = true;
    var searchInput = document.querySelector('#faq_search input');
    if (searchInput) searchInput.value = '';
  }

  function handleSearch(root, keyword) {
    if (!keyword) {
      resetSearch(root);
      return;
    }

    var hasMatch = false;
    root.querySelectorAll('.faq_container .faq_item').forEach(function (item) {
      if (item.textContent.indexOf(keyword) !== -1) {
        item.style.display = '';
        hasMatch = true;
      } else {
        item.style.display = 'none';
      }
    });

    var keywordEl = root.querySelector('.faq_search_header .keyword');
    if (keywordEl) keywordEl.textContent = keyword;

    var nav = root.querySelector('.faq_navigation');
    if (nav) nav.style.display = 'none';

    var searchResult = root.querySelector('.search_result');
    if (searchResult) searchResult.hidden = false;

    var noResult = root.querySelector('.no_result_message');
    if (noResult) noResult.hidden = hasMatch;
  }

  function initMobileNavScroll(root) {
    if (!isMobileNav()) return;

    var nav = root.querySelector('.faq_navigation');
    if (!nav) return;

    var siteHeader = document.querySelector('.site-header');
    if (siteHeader) siteHeader.style.position = 'relative';

    var target = nav.getBoundingClientRect().top + window.pageYOffset;
    window.addEventListener(
      'scroll',
      function () {
        nav.classList.toggle('fixed', window.scrollY > target);
      },
      { passive: true }
    );
  }

  function initAll() {
    document.querySelectorAll('[data-faq-main-content]').forEach(initFaqMainContent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-faq-main-content]').forEach(initFaqMainContent);
  });
})();
